import { Injectable } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { ErrorMessageResponse } from '@app/core/models/data-response';
import { DataTaskService } from '@app/core/services/data-task.service';
import { SrOperationResourceItem } from '@app/services/sr-operation.service';

@Injectable({ providedIn: 'root' })
export class SrRefundService {
    constructor(private readonly datatask: DataTaskService) {}
    /** @datatask 1616 */
    public async getTravelBill(params: SrTravelBillParams): Promise<SrTravelBillGet> { return (await this.datatask.Post(1616, params))[0]; }
    /** @datatask 1617 */
    public getTravelBillSummary(params: SrTravelBillParams & { view_id: string }): Promise<SrRefundRow[]> { return this.datatask.Post(1617, params); }
    /** @datatask 1618 */
    public async getTravelBillSpec(params: SrTravelBillSpecParams): Promise<SrTravelBillSpecGet> { return (await this.datatask.Post(1618, params))[0]; }
    /** @datatask 1619 */
    public getTravelBillSpecSummary(page: SrTravelBillSpecGet): Promise<SrRefundRow[]> { return this.datatask.Post(1619, page); }
    /** @datatask 1621 */
    public async approveTravelBill(params: SrTravelBillParams): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1621, params))[0]; }
    /** @datatask 1622 */
    public async payTravelBill(params: SrTravelBillParams): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1622, params))[0]; }
    /** @datatask 1625 */
    public async updateTravelBill(params: SrTravelBillParams): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1625, params))[0]; }
    /** @datatask 1323 */
    public async getExpenses(params: SrExpensesParams): Promise<SrExpensesGet> { return (await this.datatask.Post(1323, params))[0]; }
    /** @datatask 1322 */
    public getExpenseList(params: SrExpensesListParams): Promise<Item[]> { return this.datatask.Post(1322, params); }
    /** @datatask 1789 */
    public getInputs(params: SrRefundInputParams): Promise<SrRefundRow[]> { return this.datatask.Post(1789, params); }
    /** @datatask 1587 */
    public async getBasis(params: SrRefundParams): Promise<SrRefundBasisGet> { return (await this.datatask.Post(1587, params))[0]; }
    /** @datatask 1815 */
    public getCrews(params: { checklistdata_keyno: string }): Promise<SrRefundCrewOption[]> { return this.datatask.Post(1815, params); }
    /** @datatask 1816 */
    public getEquipment(params: { checklistdata_keyno: string }): Promise<SrRefundEquipmentOption[]> { return this.datatask.Post(1816, params); }
    /** @datatask 1589 */
    public getBasisResources(params: SrRefundParams): Promise<SrOperationResourceItem[]> { return this.datatask.Post(1589, params); }
    /** @datatask 1588 */
    public getChecklistItems(page: SrRefundBasisGet): Promise<SrRefundChecklistOption[]> { return this.datatask.Post(1588, page); }
    /** @datatask 1590 */
    public getReportRows(page: SrRefundBasisGet): Promise<SrRefundRow[]> { return this.datatask.Post(1590, page); }
    /** @datatask 1814 */
    public getRefundRows(page: SrRefundBasisGet): Promise<SrRefundRow[]> { return this.datatask.Post(1814, page); }
    /** @datatask 1609 */
    public async getCreate(params: SrRefundParams): Promise<SrRefundCreateGet> { return (await this.datatask.Post(1609, params))[0]; }
    /** @datatask 1611 */
    public getCreateResources(params: SrRefundParams): Promise<SrOperationResourceItem[]> { return this.datatask.Post(1611, params); }
    /** @datatask 1612 */
    public async getCustomer(params: { resource_id: string; custact_no: string }): Promise<SrRefundCustomerGet> { return (await this.datatask.Post(1612, params))[0]; }
    /** @datatask 1610 */
    public getCreateRows(page: SrRefundCreateGet): Promise<SrRefundRow[]> { return this.datatask.Post(1610, page); }
    /** @datatask 1608 */
    public async createRefund(page: SrRefundCreateGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1608, page))[0]; }
    /** @datatask 1785 */
    public async getCrewInput(params: SrRefundInputParams & { checklistdata_keyno: string }): Promise<SrRefundInputCrewGet> { return (await this.datatask.Post(1785, params))[0]; }
    /** @datatask 1786 */
    public async calculateCrewHours(page: SrRefundInputCrewGet): Promise<{ hours_total: string | number }> { return (await this.datatask.Post(1786, page))[0]; }
    /** @datatask 1787 */
    public async saveCrewInput(page: SrRefundInputCrewGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1787, page))[0]; }
    /** @datatask 1788 */
    public async deleteCrewInput(page: SrRefundInputCrewGet): Promise<ErrorMessageResponse> { return (await this.datatask.Post(1788, page))[0]; }
}

export interface SrExpensesParams { argtype: string; argvalue: string; }
export interface SrExpensesListParams extends SrExpensesParams {
    bg_srexpenses_main: string;
    date_fom: string;
    date_tom: string;
    dateselector_index: string;
    date_fomtom: string;
}
export interface SrExpensesGet extends SrExpensesListParams { searchtext: string; }

export interface SrTravelBillParams { travelbill_no: string; }
export interface SrTravelBillSpecParams extends SrTravelBillParams { argtype: string; argvalue: string; }
export interface SrTravelBillSpecGet extends SrTravelBillSpecParams { view_id: string; }
export interface SrTravelBillGet extends SrTravelBillParams {
    view_id: string;
    custact_no: string;
    checklistdata_keyno: string;
    special_hrsno: string;
    cust_name: string;
    cust_adr_street: string;
    org_no: string;
    bankaccount: string;
    special_resource_name_from: string;
    special_resource_name_approver: string;
    special_resource_name_processing: string;
    last_travelbilllogs_note: string;
    change_info: string;
    show_button_update_change: string;
    show_button_update: string;
    show_button_approve: string;
    show_button_reject: string;
    show_button_pay: string;
}

export interface SrRefundInputParams { srrefundinput_keyno: string; }
export interface SrRefundParams { custact_no: string; checklistdata_keyno: string; }
export interface SrRefundBasisGet extends SrRefundParams {
    webpage_heading: string; bg_srrefundbasis_main: string; srcrew_keyno: string; srequipment_keyno: string;
    special_resource_id_from: string; checklistitem_keyno: string; show_create_refund: string;
}
export interface SrRefundCrewOption { srcrew_keyno: string; srcrew_name: string; }
export interface SrRefundEquipmentOption { srequipment_keyno: string; srequipment_name: string; }
export interface SrRefundChecklistOption { checklistitem_keyno: string; method: string; }
export interface SrRefundColumn extends Record<string, unknown> { item_id?: string | number; item_col: string; item_col_width?: string | number; }
export interface SrRefundRow extends Item { item_secondary?: SrRefundColumn[]; item_col_width?: string | number; item_type?: string; }
export interface SrRefundCustomerGet {
    org_no: string; cust_no: string; cust_name: string; cust_adr_street: string; bankaccount: string;
    send_to_resource_id: string; send_to_resource_name: string;
}
export interface SrRefundCreateGet extends SrRefundParams, SrRefundCustomerGet { webpage_heading: string; special_resource_id_from: string; }

export interface SrRefundInputCrewGet extends SrRefundInputParams {
    checklistdata_keyno: string;
    diver_hours_diving: string | number;
    diver_hours_lineman: string | number;
    diver_info: string;
    diver_was: string;
    food_served: string;
    fullname: string;
    has_signed_out: string;
    hours_total: string | number;
    info_food: string;
    info_private_car: string;
    note: string;
    page_heading: string;
    private_car: string;
    private_car_km: string | number;
    private_car_km_forest_road: string | number;
    private_car_km_passenger: string | number;
    private_car_km_trailer: string | number;
    private_car_name_of_passengers: string;
    private_car_nbr_of_passengers: string | number;
    private_car_regno: string;
    private_car_use_taxable_rate: string;
    private_car_use_taxable_rate_info: string;
    rescuedog_info: string;
    rescuedog_was: string;
    resource_id: string;
    resource_name: string;
    roadtoll_amount: string | number;
    roadtoll_has: string;
    roadtoll_info: string;
    roadtoll_note: string;
    signin_dt: string;
    signin_dt_helptext: string;
    signout_dt: string;
    signout_dt_helptext: string;
    smallboat_helpman: string;
    smallboat_helpman_hours: string | number;
    smallboat_info: string;
    srrefundinput_keyno: string;
    srrefundtype_id: string;
}
